// @flow

import React from 'react';
import { connect } from 'react-redux';
import { Error } from './atoms';
import { TileSelect, Tile } from '../tileSelect';
import OptionPrice from '../optionPrice';
import { getClaimFrees } from '../../../../store/configuration/actives';
import {
  getActiveClaimFreeId,
  selectClaimFree,
} from '../../../../store/configuration';
import { getPerMonthAbbrv } from '../../../../store/configuratorSettings/selectors';
import type { Claimfree as ClaimfreeType } from '../../../../types/pdb';

export const ERROR_ID = 'claimfree-error';

type OwnProps = {|
  blocksPerRow: number,
  errorText?: ?string,
  showError?: boolean,
  variant?: ?string,
  pdbId?: ?string, // eslint-disable-line react/no-unused-prop-types
|};

type StateProps = {|
  claimfrees: Array<ClaimfreeType>,
  activeClaimfree: ?number,
  postfix: string,
|};

type DispatchProps = {|
  setClaimfree: Function,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
  ...DispatchProps,
|};

const Claimfree = ({
  activeClaimfree,
  blocksPerRow,
  claimfrees,
  errorText,
  setClaimfree,
  showError,
  variant,
  postfix,
}: Props) => (
  <div id={ERROR_ID}>
    {showError && <Error>{errorText}</Error>}
    <TileSelect>
      {claimfrees.map(({
        id, name, price, most_chosen,
      }) => (
        <Tile
          key={id}
          active={activeClaimfree === id}
          onClick={() => setClaimfree(id)}
          blocksPerRow={blocksPerRow}
          blockCount={claimfrees.length}
          mostChosen={most_chosen}
          variant={variant}
        >
          <OptionPrice
            title={name}
            price={parseInt(price, 10)}
            active={activeClaimfree === id}
            postfix={postfix}
          />
        </Tile>
      ))}
    </TileSelect>
  </div>
);

Claimfree.defaultProps = {
  errorText: 'This field is required',
  showError: false,
  variant: null,
  pdbId: null,
};

const mapStateToProps = (state: any, { pdbId }: OwnProps): StateProps => ({
  claimfrees: getClaimFrees(state, pdbId),
  activeClaimfree: getActiveClaimFreeId(state, pdbId),
  postfix: getPerMonthAbbrv(state),
});

const mapDispatchToProps = (dispatch: Function, { pdbId }: OwnProps): DispatchProps => ({
  setClaimfree: (id: number) => dispatch(selectClaimFree(id, pdbId)),
});

export default connect<Props, OwnProps, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(Claimfree);
